export const RESET = 'EXCMNOTE_UPDATE_RESET'
export const SET_ERROR = 'EXCMNOTE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMNOTE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMNOTE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMNOTE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMNOTE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMNOTE_UPDATE_UPDATE_RETRIEVED'
